module.exports = __webpack_public_path__ + "static/img/no-date.47199f67.png";